export default {
  title_one: 'Mise à jour des stats de livraison pour « {{title}} »',
  title_other: 'Mise à jour des stats de livraison pour {{count}} campagnes',
  subtitle_pending:
    'Apple et Google confirment les accusés de réception dans environ {{minutes}}m {{seconds}}s (vers {{time}}). Les stats seront actualisées automatiquement.',
  subtitle_ready:
    'Les accusés de réception devraient être disponibles. Actualisez la page pour voir les derniers chiffres de livraison.',
};
